export const colors = {
    brand: {
        solid: {
            value: '{colors.brand.600}',
        },
        contrast: {
            value: '{colors.white}',
        },
        fg: {
            value: '{colors.brand.700}',
        },
        muted: {
            value: '{colors.brand.100}',
        },
        subtle: {
            value: '{colors.brand.200}',
        },
        emphasized: {
            value: '{colors.brand.300}',
        },
        focusRing: {
            value: '{colors.focusRing}',
        },
    },

    secondary: {
        solid: {
            value: '{colors.secondary.600}',
        },
        contrast: {
            value: '{colors.white}',
        },
        fg: {
            value: '{colors.secondary.700}',
        },
        muted: {
            value: '{colors.secondary.50}',
        },
        subtle: {
            value: '{colors.secondary.100}',
        },
        emphasized: {
            value: '{colors.secondary.300}',
        },
        focusRing: {
            value: '{colors.focusRing}',
        },
    },

    yellow: {
        solid: {
            value: '{colors.yellow.600}',
        },
        contrast: {
            value: '{colors.black}',
        },
        fg: {
            value: '{colors.yellow.700}',
        },
        muted: {
            value: '{colors.yellow.50}',
        },
        subtle: {
            value: '{colors.yellow.100}',
        },
        emphasized: {
            value: '{colors.yellow.300}',
        },
        focusRing: {
            value: '{colors.focusRing}',
        },
    },

    gray: {
        contrast: {
            value: { _light: '{colors.white}', _dark: '{colors.black}' },
        },
        fg: {
            value: { _light: '{colors.gray.900}', _dark: '{colors.gray.200}' },
        },
        subtle: {
            value: { _light: '{colors.gray.100}', _dark: '{colors.gray.950}' },
        },
        muted: {
            value: { _light: '{colors.gray.200}', _dark: '{colors.gray.800}' },
        },
        emphasized: {
            value: { _light: '{colors.gray.300}', _dark: '{colors.gray.700}' },
        },
        solid: {
            value: { _light: '{colors.gray.950}', _dark: '{colors.white}' },
        },
        focusRing: {
            value: '{colors.focusRing}',
        },
    },

    selectiveYellow: {
        value: '#ffb400',
    },

    logoPrimary: {
        value: '#ff3939',
    },

    border: {
        value: { _light: '{colors.gray.300}', _dark: '{colors.gray.700}' },
    },

    bodyText: {
        value: { _light: '{colors.gray.900}', _dark: '{colors.white}' },
    },

    placeholder: {
        value: { _light: '{colors.gray.600}', _dark: '{colors.gray.400}' },
    },

    focusRing: {
        value: { _light: '{colors.secondary.500/20}', _dark: '{colors.secondary.600/20}' },
    },
};
